import React, { Component } from "react";

import "./Bottom.less";

export default class Bottom extends Component {

  onDivRef = (e) => {
    if (e) {
      const pEle = e.parentElement;
      if (pEle.classList.contains("nano-panel")) {
        // 调整父 .nano-panel 的 垂直布局
        pEle.style.flexDirection = "column";
      }
    };
  }

  render() {
    const style = {
      ...this.props.style,
      height: this.props.height,
    };
    return (
      <div
        className="nano-panel-bottom"
        style={style}
        ref={this.onDivRef}
      >
        {this.props.children}
      </div>
    );
  };
}
